export default {
  securitySection: {
    title: {
      fr: "Sécurisez vos espaces avec des alarmes.",
      en: "Smart security, made simple.",
    },
    items: {
      notifications: {
        title: {
          fr: "Être alerté en cas d’intrusion.",
          en: "Instant alerts when it matters.",
        },
        description: {
          fr: "Choisissez qui alerter et recevez une notification en cas d’armement, d’intrusion et de désarmement de votre alarme.",
          en: "Choose who gets notified and stay informed whenever your alarm is armed, triggered, or disarmed.",
        },
      },
      sensors: {
        title: {
          fr: "Des mini-capteurs pour créer votre alarme.",
          en: "Discret sensors that fit anywhere.",
        },
        description: {
          fr: "Une autonomie jusqu’à 15 ans et plus...!",
          en: "Up to 15 years of battery life...!",
        },
        functions: {
          open: {
            title: {
              fr: "Ouverture",
              en: "Door and window detection",
            },
            description: {
              fr: "Coulissante & battante.",
              en: "Sliding and hinged openings.",
            },
          },
          light: {
            title: {
              fr: "Mouvement & Luminosité",
              en: "Motion & light",
            },
            description: {
              fr: "Discret.",
              en: "Invisible.",
            },
          },
        },
      },
    },
  },
};
